import { render, staticRenderFns } from "./Unanswered.vue?vue&type=template&id=02a6ad83"
import script from "./Unanswered.vue?vue&type=script&lang=ts"
export * from "./Unanswered.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports